// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"43":"test","182":"exam2","657":"report2"}[chunkId] + "." + {"43":"7ef06c9d","182":"25da6e3a","657":"21d31c6b"}[chunkId] + ".css";
};